<template>
    <q-page class="">
        <div class="q-display-1">Artykuły</div>

        <template v-if="articles.length > 0">
            <div class="virtualCollectionWrapper" ref="virtualCollectionWrapper">
                <virtual-collection
                    :collection="articles"
                    :height="virtualHeight"
                    :width="virtualWidth"
                    :cellSizeAndPositionGetter="cellSizeAndPositionGetter"
                >
                    <article-component
                        slot="cell"
                        slot-scope="props"
                        class="article-component"
                        :inline="true"
                        :model="props.data"
                        :kb="kb"/>
                </virtual-collection>
            </div>

<!--            <article-component-->
<!--                class="article-component"-->
<!--                :inline="true"-->
<!--                :model="model"-->
<!--                :key="model.articleId"-->
<!--                :kb="kb"-->
<!--                v-for="model in articles"/>-->

        </template>
        <template v-else>
            Brak artykułów
        </template>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="add_circle"
                class="q-pa-sm"
                color="primary"
                @click="addNew">
                <q-tooltip anchor="top left">
                    Dodaj
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </q-page>
</template>
<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import ArticleComponent from './pole/ArticleComponent'
    import FixedButtons from './FixedButtons'

    export default {
        name: 'Articles',
        components: {FixedButtons, ArticleComponent, QBtn, QTooltip, QIcon},
        mounted () {
            this.updateContainerDimensions();

            window.addEventListener('resize', this.updateContainerDimensions, 'false');
            if (window.ResizeObserver) {
                this.ro = new ResizeObserver(this.updateContainerDimensions)
                .observe(this.$refs.virtualCollectionWrapper);
            }
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.updateContainerDimensions);
            if (this.ro) {
                this.ro.unobserve(this.$refs.virtualCollectionWrapper);
                this.ro.disconnect();
            }
        },
        methods: {
            addNew () {
                if (this.kb) {
                    this.$router.push({
                        name: 'article-add'
                    })
                } else {
                    this.$router.push({
                        name: 'polearticles-add'
                    })
                }
            },
            updateContainerDimensions() {
                if (this.$refs.virtualCollectionWrapper) {
                    const maxW = this.$refs.virtualCollectionWrapper.clientWidth;
                    const maxH = window.innerHeight - this.$refs.virtualCollectionWrapper.getBoundingClientRect().top
                    this.virtualWidth = maxW;
                    this.virtualHeight = maxH;
                }
            },
            cellSizeAndPositionGetter(item, index) {
                const partWidth = 350;
                const partHeight = 420;
                const maxCol = Math.floor( this.virtualWidth / partWidth)
                const totalSpace = this.virtualWidth - partWidth * maxCol;

                return {
                    width: partWidth,
                    height: partHeight,
                    x: (index % maxCol) * (partWidth + totalSpace/maxCol),
                    y: parseInt(index / maxCol) * partHeight
                }
            }

        },
        computed: {
            articles () {
                if (this.$route.name === 'polearticles') {
                    return this.$store.getters.article.map(a => ({data: a}))
                } else {
                    return this.$store.getters.kbArticle.map(a => ({data: a}))
                }
            },
            kb () {
                return this.$route.name === 'articles'
            }
        },
        data () {
            return {
                virtualWidth: 0,
                virtualHeight: 0,
                ro: undefined,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .article-component {
        min-height: 400px;
    }

    .virtualCollectionWrapper {
        width: 100%;
        height: 100%;

        .vue-virtual-collection {
            scroll: auto;
        }
    }
</style>